import { BaseHelper } from 'services/BaseGraphQLAPIHelper';

import { getInFilterValue } from 'utils';

const CONTENT = `
id
pk
type
name
generalPurchaseTypeMinimumSpending
generalPurchaseTypeMinimumQuantity
generalPurchaseTypeMaximumSpending
linkedPureStores
generalPurchaseTypeSkuFileImportTime
generalPurchaseTypeEligibleNumberOfDaysSincePurchase
generalPurchaseTypeUploadTransactionEligibleDays
generalPurchaseTypeOnlyForBirthMonth
generalPurchaseTypeWillExcludeDeliveryCost
generalPurchaseTypeWillExcludeOtherCharges
generalPurchaseTypeExcludedProducts
generalPurchaseTypeOverallLimit
generalPurchaseTypePerHeadLimit
generalPurchaseTypePeriodicLimit
generalPurchaseTypePeriodicLimitEffectiveNumberOfDays
generalPurchaseTypePerHeadPeriodicLimit
generalPurchaseTypePerHeadPeriodicLimitEffectiveNumberOfDays
triggerPriority
generalPurchaseTypeLineItemRequirement
generalPurchaseTypeUseAdvancedLineItemGroups
generalPurchaseTypeLineItemGroupsUseOrRelationship
generalPurchaseTypeLineItemGroups {
    pk
    minimumSpending
    minimumQuantity
    sku
    brand {
        pk
        name
    }
    category {
        pk
        name
    }
    subcategory {
        pk
        name
    }
    transactionAdditionalData {
        pk
        field {
            pk
            fieldName
        }
        value
    }
    purchasedItemAdditionalData {
        pk
        field {
            pk
            fieldName
        }
        value
    }
}
generalPurchaseTypeRewardLogicType
generalPurchaseTypeRewardAmountLogicType
generalPurchaseTypeRewardAmountBasedType
generalPurchaseTypeRewardType
generalPurchaseTypePointsRewardTypePointsPerXValue
generalPurchaseTypePointsRewardTypeX
generalPurchaseTypePointsRewardTypeTpeX
generalPurchaseTypePointsRewardTypeTpePerXValue
generalPurchaseTypeStampRewardTypeStampsPerXValue
generalPurchaseTypeStampRewardTypeX
generalPurchaseTypeCouponRewardTypeCouponTemplate {
  pk
  id
  name
  toDelete
}
generalPurchaseTypeCouponRewardTypeCouponX
generalPurchaseTypeCouponRewardTypeCouponPerXValue

generalPurchaseTypeOverallRewardLimit
generalPurchaseTypeOverallLimit
generalPurchaseTypePeriodicType
generalPurchaseTypePeriodicLimitEffectiveNumberOfDays
generalPurchaseTypePeriodicFollowActivePeriod
generalPurchaseTypePeriodicStartTime
generalPurchaseTypePeriodicEndTime
generalPurchaseTypePeriodicRewardLimit
generalPurchaseTypePeriodicLimit

generalPurchaseTypePerHeadRewardLimit
generalPurchaseTypePerHeadLimit
generalPurchaseTypePerHeadPeriodicType
generalPurchaseTypePerHeadPeriodicLimitEffectiveNumberOfDays
generalPurchaseTypePerHeadPeriodicFollowActivePeriod
generalPurchaseTypePerHeadPeriodicStartTime
generalPurchaseTypePerHeadPeriodicEndTime
generalPurchaseTypePerHeadPeriodicRewardLimit
generalPurchaseTypePerHeadPeriodicLimit
generalPurchaseTypePerTransactionRewardLimit

memberReferralTypeBeneficiary
memberReferralTypeLimit
memberReferralTypeRewardType
memberReferralTypePointsRewardTypePoints
memberReferralTypePointsRewardTypeTpe
memberReferralTypeStampRewardTypeQuantity
memberReferralTypeCouponRewardTypeCouponTemplate {
  pk
  id
  name
  toDelete
}
memberReferralTypeCouponRewardTypeQuantity
newMemberTypeRequirePromotionCode
newMemberTypePromotionCodeUsageMaxLimit
newMemberTypePromotionCode
newMemberTypePromotionCodeAvailableTimes
newMemberTypeRewardType
newMemberTypePointsRewardTypePoints
newMemberTypePointsRewardTypeTpe
newMemberTypeStampRewardTypeQuantity
newMemberTypeCouponRewardTypeCouponTemplate {
  pk
  id
  name
  toDelete
}
newMemberTypeCouponRewardTypeQuantity
birthdayTypeRewardType
birthdayTypePointsRewardTypePoints
birthdayTypePointsRewardTypeTpe
birthdayTypeStampRewardTypeQuantity
birthdayTypeCouponRewardTypeCouponTemplate {
  pk
  id
  name
  toDelete
}
birthdayTypeCouponRewardTypeQuantity
qrCodeScanningTypeQrCodes
qrCodeScanningTypeOverallLimit
qrCodeScanningTypePerHeadLimit
qrCodeScanningTypePeriodicLimit
qrCodeScanningTypePeriodicLimitEffectiveNumberOfDays
qrCodeScanningTypePerHeadPeriodicLimit
qrCodeScanningTypePerHeadPeriodicLimitEffectiveNumberOfDays
qrCodeScanningTypeRewardType
qrCodeScanningTypePointsRewardTypePoints
qrCodeScanningTypePointsRewardTypeTpe
qrCodeScanningTypeStampRewardTypeQuantity
qrCodeScanningTypeCouponRewardTypeCouponTemplate {
  pk
  id
  name
  toDelete
}
qrCodeScanningTypeCouponRewardTypeQuantity
gpsCheckInTypeLatitude
gpsCheckInTypeLongitude
gpsCheckInTypeRadiusInMeter
gpsCheckInTypeOverallLimit
gpsCheckInTypePerHeadLimit
gpsCheckInTypePeriodicLimit
gpsCheckInTypePeriodicLimitEffectiveNumberOfDays
gpsCheckInTypePerHeadPeriodicLimit
gpsCheckInTypePerHeadPeriodicLimitEffectiveNumberOfDays
gpsCheckInTypeRewardType
gpsCheckInTypePointsRewardTypePoints
gpsCheckInTypePointsRewardTypeTpe
gpsCheckInTypeStampRewardTypeQuantity
gpsCheckInTypeCouponRewardTypeCouponTemplate {
  pk
  id
  name
  toDelete
}
gpsCheckInTypeCouponRewardTypeQuantity
fillingFormTypeForm {
  pk
  id
  name
}
fillingFormTypeDefinitionType
fillingFormTypeOverallLimit
fillingFormTypePerHeadLimit
fillingFormTypePeriodicLimit
fillingFormTypePeriodicLimitEffectiveNumberOfDays
fillingFormTypePerHeadPeriodicLimit
fillingFormTypePerHeadPeriodicLimitEffectiveNumberOfDays
fillingFormTypeRewardType
fillingFormTypePointsRewardTypePoints
fillingFormTypePointsRewardTypeTpe
fillingFormTypeCouponRewardTypeCouponTemplate {
  pk
  id
  name
  toDelete
}
fillingFormTypeCouponRewardTypeQuantity
levelUpgradeTypeLevelGoal{
  pk
  id
  levelName
}
levelUpgradeTypePerHeadPeriodicLimit
levelUpgradeTypePerHeadPeriodicLimitEffectiveNumberOfDays
levelUpgradeTypeRewardType
levelUpgradeTypePointsRewardTypePoints
levelUpgradeTypePointsRewardTypeTpe
levelUpgradeTypeCouponRewardTypeCouponTemplate {
  pk
  id
  name
  toDelete
}
levelUpgradeTypeCouponRewardTypeQuantity
levelUpgradeTypeStampRewardTypeQuantity
creationDate
lastModifiedDate
lastModifiedBy
lastModifiedByAdmin {
  id
  pk
  username
}
linkedCampaignType
campaigns {
  edges {
    node {
      id
      pk
      name
      numberOfCustomersVisible
    }
  }
}
stampTaskRelation{
  edges{
    node{
      stampCampaign{
        pk
        name
      }
    }
  }
}
startDate
endDate
blackoutPeriod {
  edges{
    node {
      pk
      startDate
      endDate
    }
  }
}
blackoutWeekday
isExclusive
targetType
targetedSegments {
  edges {
    node {
      pk
      name
    }
  }
}
targetedLevels {
  edges {
    node {
      pk
      levelName
    }
  }
}
excludeBlacklistSegment
targetedBlacklistSegments {
  edges {
    node {
      pk
      name
    }
  }
}
`;

export const getSimpleEarningRules = (afterCursor, searchNameOrId = '', earningRuleIds, linkedCampaignType) => {
  let moreSearch = '';
  if (earningRuleIds) {
    moreSearch += `, idIn: ${getInFilterValue(earningRuleIds)}`;
  } 
  if (linkedCampaignType) {
    moreSearch += `, linkedCampaignType: "${linkedCampaignType}"`;
  }
  const query = `{
    earningRules(first: 20, after: "${afterCursor}", searchNameOrId: "${searchNameOrId}"
      ${moreSearch}) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          pk
          name
        }
      }
    }
  }
  `
  const variables = {
    input: {},
  };

  // console.log('@@338: ', query);

  return BaseHelper.callGraphQLAPI({ query, variables });
}

export const getEarningRulesWithType = (
  afterCursor,
  rank,
  type,
  nameContains = '',
  otherSearch,
  linkedCampaignType,
) => {
  let order = rank ? '-pk' : 'pk';
  if (otherSearch?.sort) {
    order = otherSearch.sort;
  }

  let moreSearch = '';
  if (otherSearch?.rewardType) {
    moreSearch += `, rewardTypeIn: ${getInFilterValue(otherSearch.rewardType)}`;
  }
  if (otherSearch?.targetCustomer && otherSearch?.[otherSearch.targetCustomer]) {
    let targetCustomerFieldFilter = otherSearch.targetCustomer
    if (["dynamicSegmentsIn", "staticSegmentsIn"].includes(targetCustomerFieldFilter)) {
      targetCustomerFieldFilter = "segmentsIn"
    }
    moreSearch += `, ${targetCustomerFieldFilter}: ${getInFilterValue(
      otherSearch[otherSearch.targetCustomer],
    )}`;
  }
  if (otherSearch?.typeIn?.length > 0) {
    moreSearch += `, typeIn: ${getInFilterValue(otherSearch?.typeIn)}`;
  }
  if (otherSearch?.customerId) {
    moreSearch += `, customerId: ${otherSearch?.customerId}`;
  }
  if ("requirePromotionCode" in otherSearch && ![undefined, null].includes(otherSearch?.requirePromotionCode)) {
    moreSearch += `, requirePromotionCode: ${Boolean(otherSearch?.requirePromotionCode)}`;
  }

  const query = `{
    earningRules(first: 20, after: "${afterCursor}", nameIcontains: "${nameContains}", type: "${
    type === 'all' || type === undefined ? '' : type
  } ", orderBy: "${order}"${moreSearch}, ${
    linkedCampaignType ? 'linkedCampaignType: "' + linkedCampaignType + '"' : ''
  }){
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          ${CONTENT}
          numberOfCustomersVisible
        }
      }
    }
  }
  `;
  const variables = {
    input: {},
  };

  // console.log('@@338: ', query);

  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const deleteEarningRules = (ids) => {
  const query = `mutation DeleteEarningRules($input: DeleteEarningRulesInput!) {
    deleteEarningRules(input: $input) {
      success
    }
  }
  `;
  const variables = {
    input: {
      ids: ids,
    },
  };

  // console.log('@@338: ', query);

  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getOneEarningRule = (id) => {
  const query = `
  {
    earningRule(id: "${id}") {
      ${CONTENT}
      instructionSectionTitle
      instructionSectionContent
      detailSectionTitle
      detailSectionContent
      recurringDate {
        pk
        activePeriodFollowBirthMonth
        activeEndOffsetDays
        activeEndOffsetMonths
        activeEndDateOffsetType
        activeEndOffsetWeeks
        activeEndSpecificDayInMonth
        activeEndOrdinalWeekdayInMonth
        activeEndSpecificWeekday
        activeStartDateOffsetType
        activeStartOffsetDays
        activeStartOffsetMonths
        activeStartOffsetWeeks
        activeStartSpecificDayInMonth
        activeStartOrdinalWeekdayInMonth
        activeStartSpecificWeekday
      }
      translations {
        edges {
          node {
            pk
            language
            name
            instructionSectionTitle
            instructionSectionContent
            detailSectionTitle
            detailSectionContent
          }
        }
      }
    }
  }
  `;
  const variables = {
    input: {},
  };

  // console.log('@@338: ', query);

  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const createOrUpdateEarningRule = (values) => {
  const action = values.id ? 'Update' : 'Create';
  let query = `mutation ${action}EarningRule($input: ${action}EarningRuleInput!) {
    ${action.toLowerCase()}EarningRule(input: $input) {
      success
      node {
        id
        pk
        type
        name
        instructionSectionTitle
        instructionSectionContent
        detailSectionTitle
        detailSectionContent
        generalPurchaseTypeMinimumSpending
        generalPurchaseTypeMaximumSpending
        linkedPureStores
        generalPurchaseTypeEligibleNumberOfDaysSincePurchase
        generalPurchaseTypeUploadTransactionEligibleDays
        generalPurchaseTypeOnlyForBirthMonth
        generalPurchaseTypeWillExcludeDeliveryCost
        generalPurchaseTypeWillExcludeOtherCharges
        generalPurchaseTypeExcludedProducts
        generalPurchaseTypeRewardType
        generalPurchaseTypePointsRewardTypePointsPerXDollarsSpent
        generalPurchaseTypePointsRewardTypeX
        generalPurchaseTypePointsRewardTypeTpePerXDollarsSpent
        generalPurchaseTypePointsRewardTypeTpeX
        generalPurchaseTypeCouponRewardTypeCouponTemplate {
          id
        }
        generalPurchaseTypeCouponRewardTypeQuantity
        generalPurchaseTypeOverallLimit
        generalPurchaseTypePerHeadLimit
        generalPurchaseTypePeriodicLimit
        generalPurchaseTypePeriodicLimitEffectiveNumberOfDays
        generalPurchaseTypePerHeadPeriodicLimit
        generalPurchaseTypePerHeadPeriodicLimitEffectiveNumberOfDays
        memberReferralTypeBeneficiary
        memberReferralTypeLimit
        memberReferralTypeRewardType
        memberReferralTypePointsRewardTypePoints
        memberReferralTypePointsRewardTypeTpe
        memberReferralTypeCouponRewardTypeCouponTemplate {
          id
        }
        memberReferralTypeCouponRewardTypeQuantity
        newMemberTypeRewardType
        newMemberTypePointsRewardTypePoints
        newMemberTypePointsRewardTypeTpe
        newMemberTypeCouponRewardTypeCouponTemplate {
          id
        }
        newMemberTypeCouponRewardTypeQuantity
        birthdayTypeRewardType
        birthdayTypePointsRewardTypePoints
        birthdayTypePointsRewardTypeTpe
        birthdayTypeCouponRewardTypeCouponTemplate {
          id
        }
        birthdayTypeCouponRewardTypeQuantity
        qrCodeScanningTypeQrCodes
        qrCodeScanningTypeOverallLimit
        qrCodeScanningTypePerHeadLimit
        qrCodeScanningTypePeriodicLimit
        qrCodeScanningTypePeriodicLimitEffectiveNumberOfDays
        qrCodeScanningTypePerHeadPeriodicLimit
        qrCodeScanningTypePerHeadPeriodicLimitEffectiveNumberOfDays
        qrCodeScanningTypeRewardType
        qrCodeScanningTypePointsRewardTypePoints
        qrCodeScanningTypePointsRewardTypeTpe
        qrCodeScanningTypeCouponRewardTypeCouponTemplate {
          id
        }
        qrCodeScanningTypeCouponRewardTypeQuantity
        gpsCheckInTypeLatitude
        gpsCheckInTypeLongitude
        gpsCheckInTypeRadiusInMeter
        gpsCheckInTypeOverallLimit
        gpsCheckInTypePerHeadLimit
        gpsCheckInTypePeriodicLimit
        gpsCheckInTypePeriodicLimitEffectiveNumberOfDays
        gpsCheckInTypePerHeadPeriodicLimit
        gpsCheckInTypePerHeadPeriodicLimitEffectiveNumberOfDays
        gpsCheckInTypeRewardType
        gpsCheckInTypePointsRewardTypePoints
        gpsCheckInTypePointsRewardTypeTpe
        gpsCheckInTypeCouponRewardTypeCouponTemplate {
          id
        }
        gpsCheckInTypeCouponRewardTypeQuantity
        fillingFormTypeForm {
          id
        }
        fillingFormTypeDefinitionType
        fillingFormTypeOverallLimit
        fillingFormTypePerHeadLimit
        fillingFormTypePeriodicLimit
        fillingFormTypePeriodicLimitEffectiveNumberOfDays
        fillingFormTypePerHeadPeriodicLimit
        fillingFormTypePerHeadPeriodicLimitEffectiveNumberOfDays
        fillingFormTypeRewardType
        fillingFormTypePointsRewardTypePoints
        fillingFormTypePointsRewardTypeTpe
        fillingFormTypeCouponRewardTypeCouponTemplate {
          id
        }
        birthdayTypeStampRewardTypeQuantity
        generalPurchaseTypeStampRewardTypeStampsPerXDollarsSpent
        generalPurchaseTypeStampRewardTypeX
        gpsCheckInTypeStampRewardTypeQuantity
        fillingFormTypeCouponRewardTypeQuantity
        linkedCampaignType
        memberReferralTypeStampRewardTypeQuantity
        newMemberTypeStampRewardTypeQuantity
        qrCodeScanningTypeStampRewardTypeQuantity
        startDate
        endDate
        isExclusive
        targetType
        targetedSegments {
          edges {
            node {
              pk
              name
            }
          }
        }
        targetedLevels {
          edges {
            node {
              pk
              levelName
            }
          }
        }
      }
      errors {
        field
        messages
      }
    }
  }
  `;

  const variables = { input: values };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getEarningRuleList = (afterCursor = '', search) => {
  let moreSearch = 'orderBy: "-pk",';
  if (search?.linkedCampaignType) {
    moreSearch =
      moreSearch + `linkedCampaignType:"${search.linkedCampaignType}"`;
  }
  const query = `{
    earningRules(${moreSearch}){
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          ${CONTENT}
        }
      }
    }
  }`;
  const variables = {
    input: {},
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getWebhookAuthenticatedKey = (earningRuleId) => {
  const query = `{
    authenticatedKeys(first: 20, earningRuleId: ${earningRuleId}) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          pk
          key
          isCopied
        }
      }
    }
  }`;
  const variables = {
    input: {},
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const createOrUpdateWebhookAuthenticatedKey = (values) => {
  const action = values.id ? 'Update' : 'Create';
  const query = `mutation ${action}AuthenticatedKey($input: ${action}AuthenticatedKeyInput!) {
    ${action.toLowerCase()}AuthenticatedKey(input: $input) {
      success
      node {
        id
        pk
        key
        isCopied
      }
    }
  }`;
  const variables = {
    input: values,
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getEarningRuleProducts = (
  earningRuleId,
  afterCursor,
) => {
  const query = `{
    products(first: 100, after: "${afterCursor}", earningRuleId: ${earningRuleId}){
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          pk
          skuId
          sku
          categoryName
          categoryId
        }
      }
    }
  }
  `;
  const variables = {
    input: {},
  };

  return BaseHelper.callGraphQLAPI({ query, variables });
};


export const getGlobalSettingLimitTransactionSources = ()=>{
  const query = `{
    globalLimitTransactionSources(first: 20, after: "", orderBy: "-pk") {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          key
          name
        }
      }
      }
      }`;
  const variables = {
    input: {},
  };

  return BaseHelper.callGraphQLAPI({ query, variables }); 
}
export const getGlobalLimitSettings = () => {
  const query = ` {
      globalLimitSettings(first: 1, after: "", orderBy: "-pk") {
        edges {
          node {
            pk
            rewardProgramLimit
            perMemberAllTimeLimit
            perMemberPerDayLimit
            perMemberPerWeekLimit
            perMemberPerMonthLimit
            perMemberPerYearLimit
            perTransactionLimit
          }
        }
      }
    }`;
  const variables = {
    input: {},
  };

  return BaseHelper.callGraphQLAPI({ query, variables });
}


export const updateGlobalSetting = (values) => {
  const query = `mutation UpdateGlobalLimitSetting($input: UpdateEarningRuleGlobalLimitSettingInput!) {
   updateGlobalLimitSetting(input: $input) {
      success
      errors {
          field
          messages
      }
    }
  }`;
  const variables = {
    input: values,
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
}